import React, { useState } from 'react';
import { makeStyles, withStyles } from '@mui/styles';
import { Box, Container, Grid, Typography } from '@mui/material';
import MuiTableCell from '@mui/material/TableCell';
import MuiCard from '@mui/material/Card';
import { useLocation, useNavigate, useParams } from 'react-router';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Page from '../../../../components/Page';
import POWClientDetails from './POWClientDetails';
import SearchAdvancedMD from './SearchAdvancedMD';
import AdvancedMDProfile from './AdvancedMDProfile';

interface customerInfo {
  firstName: string | undefined;
  lastName: string | undefined;
  dob: number | undefined;
  gender: string | undefined;
  mobilePhone: string | undefined;
  email: string | undefined;
  linkStatus: string | undefined;
}

const columnBorders = '1px solid lightgrey';
export const AMDLinkBlueText = '#0D6DA0';
const AMDLinkGreyText = '#5E6268';
export const AMDLinkStyles: any = makeStyles((theme: any) => ({
  root: {
    marginTop: 16
  },
  margin: {
    marginBottom: theme.spacing(3)
  },
  errorMessage: {
    color: 'red',
    display: 'block'
  },
  columnContainer: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important'
  },
  columnSection: {
    borderTop: columnBorders,
    marginTop: '-10px'
  },
  column: {
    borderLeft: columnBorders
  },
  debug: {
    border: '1px solid red'
  },
  columnHeader: {
    fontWeight: 'normal',
    fontSize: '16px',
    marginBottom: '20px'
  },
  powNameText: {
    fontWeight: '600',
    fontSize: '24px'
  },
  amdNameText: {
    color: AMDLinkBlueText,
    fontWeight: '600',
    fontSize: '24px'
  },
  strongText: {
    fontWeight: '600',
    fontSize: '16px'
  },
  text: {
    fontWeight: '400',
    fontSize: '16px'
  },
  lightText: {
    color: AMDLinkGreyText,
    fontWeight: '400',
    fontSize: '16px'
  },
  searchText: {
    color: AMDLinkBlueText,
    fontWeight: '400',
    fontSize: '16px'
  },
  searchChevron: {
    color: AMDLinkBlueText
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 15px 10px 30px',
    justifyContent: 'space-between'
  },
  dialogTitleContent: {
    display: 'flex',
    alignItems: 'center',
    margin: '8px 0px'
  },
  dialogButtons: {
    width: '100%',
    display: 'flex',
    padding: '10px',
    justifyContent: 'flex-end'
  }
}));

export const AMDLinkTableCell = withStyles({
  root: {
    border: '1px solid #FFFFFF',
    paddingTop: '2px',
    paddingBottom: '2px',
    paddingLeft: '0px'
  }
})(MuiTableCell);

export const AMDLinkCard = withStyles({
  root: {
    border: '1px solid #e0e0e0',
    boxShadow: 'none'
  }
})(MuiCard);

function AdvancedMDLink() {
  const classes = AMDLinkStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams<{ id?: string }>();
  const [patient, setPatient] = useState(null);

  React.useEffect(() => {
    if (!location.state) {
      navigate(`/customer/profile/${params.id}`);
    }
  }, [location.state]);

  const customerInfo = location.state as customerInfo;
  const customerData = { id: Number(params.id), ...customerInfo };

  const handleSetPatient = (patient: any) => {
    setPatient(patient);
  };

  const handleNavigateProfile = id => {
    navigate(`/customer/profile/${id}`);
  };

  return (
    <Page title={'Link AdvancedMD | Client'}>
      <Container maxWidth="xl" className={classes.columnContainer}>
        <Grid container mb={-8}>
          <Grid item xs={12} sx={{ padding: '16px 8px' }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              onClick={() => handleNavigateProfile(params.id)}
            >
              <ChevronLeftIcon color="primary" />
              <Typography variant="body2" color="primary">
                Back to profile
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid container className={classes.columnSection}>
            <Grid item xs={12} md={4} className={classes.column}>
              <POWClientDetails customerData={customerData} />
            </Grid>
            <Grid item xs={12} md={4} className={classes.column}>
              <SearchAdvancedMD
                customerData={customerData}
                patientId={patient?.patientId}
                setPatient={handleSetPatient}
              />
            </Grid>
            <Grid item xs={12} md={4} className={classes.column}>
              <AdvancedMDProfile
                customerData={customerData}
                patientData={patient}
                navigateProfile={handleNavigateProfile}
                setPatient={handleSetPatient}
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}

export default AdvancedMDLink;
